/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/
import plonevoltoSlate from '@plone/volto-slate';
import voltoGardensports from 'volto-gardensports';

const addonsInfo = [{"name":"@plone/volto-slate","version":"19.0.5","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/home/garden/gardensports/frontend/core/packages/volto-slate/src","hasServerConfig":false,"packageJson":"/home/garden/gardensports/frontend/core/packages/volto-slate/package.json","basePath":"/home/garden/gardensports/frontend/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"volto-gardensports","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/home/garden/gardensports/frontend/packages/volto-gardensports/src","hasServerConfig":false,"packageJson":"/home/garden/gardensports/frontend/packages/volto-gardensports/package.json","basePath":"/home/garden/gardensports/frontend/packages/volto-gardensports","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"volto-gardensports/*":["./src/*"]}],"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, voltoGardensports];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config);
};
export default load;
